import { render, staticRenderFns } from "./quote-quick-view-modal.vue?vue&type=template&id=dff1d878&"
import script from "./quote-quick-view-modal.vue?vue&type=script&lang=ts&"
export * from "./quote-quick-view-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports